import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';

const getTicketTypesForPage = async ({ pageId, token, sellerId }) => {
  return fetcher(`/sellers/${sellerId}/ticket-types/${pageId}`, token);
};

export default function useEventTicketQueries() {
  const { token, sellerId } = useAuth();

  return {
    getTicketTypesForPage: pageId => getTicketTypesForPage({ pageId, token, sellerId }),
  };
}
